module.exports = __webpack_public_path__ + "static/media/jahzeer-terrell.52828b24.md";